// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mockup-list[data-v-2ec26e66]{display:grid;gap:6px;padding:6px;margin:0}.mockup-list__item[data-v-2ec26e66]{display:grid;grid-template-columns:1fr auto;background-color:#f2f2f4;padding:6px}.mockup-list__item--disabled[data-v-2ec26e66]{color:rgba(0,0,0,.5)}.mockup-list__item-title[data-v-2ec26e66]{margin:0;display:flex;align-items:center}", ""]);
// Exports
module.exports = exports;
